import { useEffect, useState } from 'react';
import apiClient from 'services/api';

/**
 * The JazzCash account customers pay for the house store's own items -- the house
 * store's saved payment settings (admin -> Stores -> house store -> Payment details).
 * Never a hardcoded number: null until loaded / when none is saved (hide JazzCash then).
 */
let cache = null;

export function fetchHouseWallet() {
  if (!cache) {
    cache = apiClient.get('/checkout/house-wallet').then((r) => r.data).catch(() => {
      cache = null;
      return { jazzcash_number: null, jazzcash_name: null };
    });
  }
  return cache;
}

export default function useHouseWallet() {
  const [wallet, setWallet] = useState({ jazzcash_number: null, jazzcash_name: null, loaded: false });
  useEffect(() => {
    let alive = true;
    fetchHouseWallet().then((w) => alive && setWallet({ ...w, loaded: true }));
    return () => { alive = false; };
  }, []);
  return wallet;
}
